import _ from 'lodash';

export const getSingleSingOnState = state => _.get(state, 'sso');
